import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import { useAuthentificationStore } from '../contexts/AuthenticationStore'
import { logOutSso } from '../services/AuthentificationService'
import { getRefreshToken } from '../services/TokenService'

const SignOutRoute = () => {
  const navigate = useNavigate()
  const { signOut } = useAuthentificationStore(
    useShallow((state) => ({
      signOut: state.signOut,
    }))
  )

  useEffect(() => {
    const signOutAndRedirect = async () => {
      const refreshToken = getRefreshToken()
      let logoutUrl = null
      if (refreshToken) {
        try {
          const result = await logOutSso(refreshToken)
          logoutUrl = result?.data?.logoutUrl
        } catch (error) {
          console.warn('[SignOut] Logout SSO indisponible, déconnexion locale uniquement', error)
        }
      }

      signOut()
      if (logoutUrl && logoutUrl !== '/') {
        window.location.assign(logoutUrl)
      } else {
        navigate('/')
      }
    }

    signOutAndRedirect()
  }, [navigate, signOut])

  return null
}

export default SignOutRoute
